import React from "react";
import { LULCMap } from "./LulcMap.V2";
import ReProjectSpecificParameter from "./ReProjectSpecificParameter";

const RecommendationPlanetTab = () => {
  return (
    <div className="grid grid-cols-12 gap-4">
      {/* accordion view goes here */}
      <div className="col-span-6">
        <ReProjectSpecificParameter />
      </div>
      <div className="col-span-6">
        <h1 className="font-medium">Map View</h1>
        <LULCMap />
      </div>
    </div>
  );
};

export default RecommendationPlanetTab;
